module.exports = __webpack_public_path__ + "static/img/logo-ViewmedDigitactil-es.c9a62d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-ViewmedDigitactil-es.png
// module id = 0zHw
// module chunks = 0